import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { breakpoints, colors } from '@/styles'
import { LeftArrowIconGrey16 } from '@/components/icons'

const Button = styled.button`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.grey16};
  background: none;
  border: none;
  text-align: left;
  margin-bottom: 16px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;

  > svg {
    margin-right: 10px;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    margin-bottom: 24px;
  }
`

const BackButton = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <Button onClick={onClick}>
      <LeftArrowIconGrey16 />
      {t('common.back', 'Back')}
    </Button>
  )
}

export default BackButton
